/**
 * @generated SignedSource<<b8b211ececef0ea8ec48f47921802ebb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChannelView_channel",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Messages_channel"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OwnedChannel",
      "kind": "LinkedField",
      "name": "owned",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Channel_channel"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Invitations_channel"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Users_channel"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JoinedChannel",
      "kind": "LinkedField",
      "name": "joined",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "channelId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Channel",
  "abstractKey": null
};
})();

node.hash = "8c784bbc1bcd6503bd50295f8e816c9e";

export default node;
